<app-tables
  [tableHeader]="'Doctor Report'"
  [data]="data"
  [totalCount]="totalCount"
  [columns]="columns"
  [filters]="filters"
  (onChangeFilterValues)="onChangeFilterValues($event)"
  (onChangePage)="changePage($event)"
  [totalPage]="totalPage"
></app-tables>
